export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';
export const DEFAULT_THEME = LIGHT_THEME;
